import React from 'react';
import styled from 'styled-components';
import { Button, color } from '@workboard/wobo-ui';
import { useTranslation } from 'react-i18next';

function Presets({
  className,
  onReset,
  onDismiss,
  onSubmit,
  ...props
}) {
  const { t } = useTranslation();
  return (
    <div className={className} {...props}>
      <Button style={{marginRight:"auto", marginLeft: "8px"}} onClick={onReset} variant="tertiary">
        {t('Clear')}
      </Button>
      <Button onClick={onDismiss} variant="ghost">
        {t('Cancel')}
      </Button>
      <Button onClick={onSubmit} variant="primary">
        {t('Apply')}
      </Button>
    </div>
  );
}

export default styled(Presets)`
  align-items: center;
  display: flex;
  justify-content: flex-end;
  padding: 0 16px 24px;
  ${Button} {
    margin: 8px 8px 0 0;
    &[data-selected='true'] {
      background: ${color('--blue-200')};
    }
  }
`;